<template>
  <component :is="component" v-bind="attrs"></component>
</template>

<script>
import { getCookie } from "@/utils/cookies";
import { checkCustomRouteAccess } from "@/router/helper";
import i18n from "@/i18n";
import { LAYOUT_MAIN, LAYOUT_V2 } from "@/utils/variables";
import store from "../../store/index";
import { getDocumentUrl } from "@/utils/mediaHelper";
import { defineAsyncComponent, markRaw } from "vue";

export default {
  name: "custom-page",
  data() {
    return {
      component: null,
      attrs: {},
    };
  },

  async beforeRouteEnter(to, from, next) {
    let component;
    const attrs = {};

    try {
      const password = getCookie(to.path);
      let page = store.getters["customPage/getCustomPage"](to.path);

      if (!page) {
        page = await store.dispatch("customPage/getCustomPage", to.path, password || null);
      }

      if (page.type === "landing") {
        const landing = page["landing_" + i18n.global.locale];

        component = defineAsyncComponent(() => import("@/pages/landing"));
        attrs.landing = landing;

        //todo: temp solution, remove once v2 layout is adapted to logged in users
        if (store.getters["user/isLoggedIn"]) {
          await next(store.getters["user/getLandingUrl"]);
          return;
        }

        to.meta.landing_id = landing.id;
        to.meta.layout = LAYOUT_V2;
      } else {
        page = await checkCustomRouteAccess(to.path, page);

        if (page.type === "transforming_links") {
          window.location.href = page.source;
          return;
        }

        component = defineAsyncComponent(() => import("@/pages/embedded-document"));
        attrs.embedded = getDocumentUrl(page.source);
      }
    } catch (e) {
      component = defineAsyncComponent(() => import("@/pages/page404"));
      to.meta.layout = store.getters["user/isLoggedIn"] ? LAYOUT_MAIN : LAYOUT_V2;
    }

    next((vm) => {
      vm.component = markRaw(component);
      vm.attrs = attrs;
    });
  },
};
</script>
